import api from '@/services/api';

export default {
  async getBudgetGLAccounts(budgetIterationId, groupId, includeHistoricActuals) {
    try {
      let response = await api.get(`BudgetGLAccounts?budgetIterationId=${budgetIterationId}&groupId=${groupId}&includeHistoricActuals=${includeHistoricActuals}`);
      if (response && response.status == 200 && response.data) {
        return response.data;
      }
      return [];
    } catch (ex) {
      console.error(ex);
      return [];
    }
  },
  async updateBudgetGLAccounts(budgetIterationId, budgetGLAccounts, lastModifiedTimestamp) {
    try {
      let requestBody = {
        budgetIterationId: budgetIterationId,
        budgetGLAccounts: budgetGLAccounts,
        lastModifiedTimestamp: lastModifiedTimestamp
      };
      let response = await api.post('BudgetGLAccounts', requestBody);
      if (response && response.status == 200) {
        return response;
      }
      return false;
    } catch (ex) {
      console.error(ex);
      return false;
    }
  },
  async getComments(budgetIterationId, glAccountId) {
    let response = await api.get(`BudgetGLAccounts/${budgetIterationId}/Comments/${glAccountId}`);
    if (response && response.status == 200) {
      return response;
    }
    return false;
  },
  async createComment(note, isFlag, repliesToNoteId, budgetIterationId, glAccountId) {
    let requestBody = {
      note: note,
      isFlag: isFlag,
      repliesToNoteId: repliesToNoteId,
      budgetIterationId: budgetIterationId,
      glAccountId: glAccountId
    };
    let response = await api.post('BudgetGLAccounts/CreateComment', requestBody);
    if (response && response.status == 200) {
      return response;
    }
    return false;
  },
  async resolveComment(budgetGLAccountNoteId, note) {
    let requestBody = {
      budgetGLAccountNoteId: budgetGLAccountNoteId,
      note: note
    };
    let response = await api.post('BudgetGLAccounts/ResolveComment', requestBody);
    if (response && response.status == 200) {
      return response;
    }
    return false;
  },
  async editComment(commentId, text) {
    let requestBody = {
      commentId: commentId,
      note: text
    };
    let response = await api.post('BudgetGLAccounts/EditComment', requestBody);
    if (response && response.status == 200) {
      return response;
    }
    return false;
  },
  async deleteComment(commentId) {
    let requestBody = {
      commentId: commentId
    };
    let response = await api.post('BudgetGLAccounts/DeleteComment', requestBody);
    if (response && response.status == 200) {
      return response;
    }
    return false;
  },
  async unresolvedFlagExists(budgetIterationId, glAccountId) {
    let response = await api.get(`BudgetGLAccounts/${budgetIterationId}/UnresolvedFlagExists/${glAccountId}`);
    if (response && response.status == 200 && response.data) {
      return response.data.unresolvedFlagExists;
    }
    return false;
  },
  async getWorkingRows(budgetIterationId, glAccountId) {
    let response = glAccountId ?
      await api.get(`BudgetGLAccounts/${budgetIterationId}/WorkingRows/${glAccountId}`) :
      await api.get(`BudgetGLAccounts/${budgetIterationId}/WorkingRows`);
    if (response && response.status == 200) {
      return response;
    }
    return false;
  },
  async createWorkingRow(budgetIterationId, glAccountId) {
    let response = await api.put(`BudgetGLAccounts/${budgetIterationId}/CreateWorkingRow/${glAccountId}`);
    if (response && response.status == 200) {
      return response;
    }
    return false;
  },
  async deleteWorkingRows(workingRows) {
    if (!workingRows || workingRows.length == 0) {
      return false;
    }
    let requestBody = {
      workingRowIds: workingRows
    };
    let response = await api.post(`BudgetGLAccounts/DeleteWorkingRows`, requestBody);
    if (response && response.status == 200) {
      return response;
    }
    return false;
  },
  async updateWorkingRow(budgetGLAccountWorkingRowId, row) {
    let response = await api.post(`BudgetGLAccounts/UpdateWorkingRow/${budgetGLAccountWorkingRowId}`, row);
    if (response && response.status == 200) {
      return response;
    }
    return false;
  },
  async createCalculation(budgetIterationId, glAccountWorkingRowIdCombinations, calculationSettings) {
    let requestBody = {
      budgetIterationId: budgetIterationId,
      glAccountWorkingRowIdCombinations: glAccountWorkingRowIdCombinations,
      calculationSettings: calculationSettings
    }
    let response = await api.put(`BudgetGLAccounts/${budgetIterationId}/Calculation`, requestBody);
    if (response && response.status == 200) {
      return response;
    }
    return false;
  },
  async getCalculations(budgetIterationId, groupId) {
    let response = await api.get(`BudgetGLAccounts/${budgetIterationId}/Calculations/${groupId}`);
    if (response && response.status == 200) {
      return response;
    }
    return false;
  },
  async reset(budgetIterationId, glAccountId) {
    let response = await api.put(`BudgetGLAccounts/${budgetIterationId}/Reset/${glAccountId}`);
    if (response && response.status == 200) {
      return response;
    }
    return false;
  },
  async updateAssumptionStatement(budgetIterationId, glAccountId, assumptionStatement) {
    try {
      let requestBody = {
        budgetIterationId: budgetIterationId,
        glAccountId: glAccountId,
        assumptionStatement: assumptionStatement
      };
      let response = await api.post(`BudgetGLAccounts/${budgetIterationId}/UpdateAssumptionStatement/${glAccountId}`, requestBody);
      if (response && response.status == 200) {
        return response;
      }
      return false;
    } catch (ex) {
      console.error(ex);
      return false;
    }
  },
  async updateBasedOnWorksheets(budgetIterationId, worksheetEntryTypeIds, additionalConcessionTransactionCategoryIds, lastModifiedTimestamp, interactedWithWorksheetEntryTypeId) {
    try {
      let requestBody = {
        budgetIterationId: budgetIterationId,
        worksheetEntryTypeIds: worksheetEntryTypeIds, // List<byte>
        additionalConcessionTransactionCategoryIds: additionalConcessionTransactionCategoryIds, // List<Guid>
        lastModifiedTimestamp: lastModifiedTimestamp,
        interactedWithWorksheetEntryTypeId: interactedWithWorksheetEntryTypeId || 0
      };
      let response = await api.post(`BudgetGLAccounts/UpdateBasedOnWorksheets/`, requestBody);
      if (response && response.status == 200) {
        return response;
      }
      return false;
    } catch (ex) {
      console.error(ex);
      return false;
    }
  },
  async getWorkingDraft(budgetIterationId) {
    let response = await api.get(`BudgetGLAccounts/${budgetIterationId}/WorkingDraft`);
    if (response && response.status == 200) {
      return response;
    }
    return false;
  },
  async checkForBulkCalculationsAssumptions(settings) {
    try {
      let requestBody = {
        templateId: (settings.templateId && settings.templateId.value),
        year: settings.year,
        startMonth: settings.startMonth || 0,
        accountingBasisId: settings.accountingBasisId,
        method: settings.method,
        amount: settings.method === 4 ? 0 : settings.amount,
        description: settings.description,
        assumptionStatement: settings.assumptionStatement,
        glAccountId: (settings.glAccountId && settings.glAccountId.value),
        propsOrGroups: (settings.propsOrGroups && settings.propsOrGroups.map((cat) => { return { propertyOrGroupId: cat.value, isPropertyGroup: cat.isPropertyGroup } })) || []
      };
      let response = await api.post('BudgetGLAccounts/CheckForBulkCalculationsAssumptions', requestBody);
      if (response && response.status == 200 && response.data) {
        return response.data;
      }
      return null;
    } catch (ex) {
      console.error(ex);
      return null;
    }
  },
  async applyBulkCalculationsAssumptions(settings) {
    try {
      let requestBody = {
        templateId: (settings.templateId && settings.templateId.value),
        year: settings.year,
        startMonth: settings.startMonth || 0,
        accountingBasisId: settings.accountingBasisId,
        method: settings.method,
        amount: settings.method === 4 ? 0 : settings.amount,
        description: settings.description,
        assumptionStatement: settings.assumptionStatement,
        glAccountId: (settings.glAccountId && settings.glAccountId.value),
        propsOrGroups: (settings.propsOrGroups && settings.propsOrGroups.map((cat) => { return { propertyOrGroupId: cat.value, isPropertyGroup: cat.isPropertyGroup } })) || [],
        bulkApplications: (settings.bulkApplications || [])
      };
      let response = await api.post('BudgetGLAccounts/ApplyBulkCalculationsAssumptions', requestBody);
      if (response && response.status == 200 && response.data) {
        return response.data;
      }
      return null;
    } catch (ex) {
      console.error(ex);
      return null;
    }
  },
  async getExistingBulkCalculationAssumptionYears() {
    try {
      let response = await api.get('BudgetGLAccounts/BulkCalculationAssumptionsYearDropdown');
      if (response && response.status == 200 && response.data) {
        return response.data;
      }
      return [];
    } catch (ex) {
      console.error(ex);
      return [];
    }
  },
  async getAllBulkCalculationsAssumptions(year) {
    try {
      let response = await api.get(`BudgetGLAccounts/BulkCalculationsAssumptions?year=${year}`);
      if (response && response.status == 200 && response.data) {
        return response.data;
      }
      return [];
    } catch (ex) {
      console.error(ex);
      return [];
    }
  },
  async setLocked(budgetIterationId, glAccountId, isLocked) {
    try {
      let requestBody = {
        budgetIterationId: budgetIterationId,
        glAccountId: glAccountId,
        isLocked: isLocked
      };
      let response = await api.post('BudgetGLAccounts/SetLocked', requestBody);
      if (response && response.status == 200 && response.data) {
        return response.data;
      }
      return null;
    } catch (ex) {
      console.error(ex);
      return null;
    }
  }
}
